import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import "./Card.css";

export type CardPadding = "none" | "sm" | "md" | "lg";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding;
  /** Renders without elevation (`box-shadow: none`). */
  flat?: boolean;
  /** Hover affordance — adds raised shadow on hover. */
  interactive?: boolean;
  /** Renders the selected state (2px aquamarine border). */
  selected?: boolean;
  /** Renders the disabled state. */
  disabled?: boolean;
  /** @deprecated Always bordered in v2.2. Use `flat` to drop the shadow. */
  bordered?: boolean;
  /** @deprecated Cards in v2.2 ship with the `raised` shadow by default. */
  elevated?: boolean;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  {
    padding = "md",
    flat = false,
    interactive = false,
    selected = false,
    disabled = false,
    className,
    children,
    ...rest
  },
  ref,
) {
  return (
    <div
      ref={ref}
      aria-disabled={disabled || undefined}
      className={cx(
        "go4-card",
        `go4-card--p-${padding}`,
        flat && "go4-card--flat",
        interactive && !disabled && "go4-card--interactive",
        selected && "go4-card--selected",
        disabled && "go4-card--disabled",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});
